/** Dashboard report API (cross-module KPI aggregation). Returns raw (unwrapped). */

import { apiGet } from "@/lib/api-client";

export type DashboardPeriod = "month" | "3m" | "6m" | "1y";

export interface DashboardKpis {
  serviceRevenueDzd: number;
  adSpendUsd: number;
  walletBalanceUsd: number;
  netProfitDzd: number;
  clientsActive: number;
  lowWallets: number;
  pendingPayments: number;
  overduePayments: number;
  totalExpensesDzd: number;
}

export interface DashboardReport {
  kpis: DashboardKpis;
  period: string;
}

export const dashboardApi = {
  get: (period: DashboardPeriod) => apiGet<DashboardReport>("/reports/dashboard", { period }),
};
